<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
import {
  orderTimeLineList,
  orderTimeDriverList,
  orderOverviewDetail,
} from 'api/operate';
import {
  getHoursDiff,
} from '@qx/utils/index';
export default {
  data () {
    return {
      orderInfo: {},
      baseForm: {
        lineNodeIndexOptions: [], // 时效路段
        userIdOptions: [], // 责任司机列表
        form: [
          {
            label: '订单编号',
            value: 'orderId',
            type: 'input',
            disabled: true,
          },
          {
            label: '订单来源',
            value: 'orderType',
            type: 'input',
            disabled: true,
          },
          {
            label: '时效路段',
            value: 'lineNodeIndex',
            type: 'select',
          },
          {
            label: '离台时间',
            value: 'orderStartDate',
            type: 'date',
            default: '',
            attr: {
              type: 'datetime',
              time: '00:00:00',
            },
            onChange: () => {
              this.calcTime();
            },
          },
          {
            label: '到达时间',
            value: 'orderArriveDate',
            type: 'date',
            default: '',
            attr: {
              type: 'datetime',
              time: '00:00:00',
            },
            onChange: () => {
              this.calcTime();
            },
          },
          {
            label: '运输时间',
            value: 'arriveTime',
            type: 'input',
            placeholder: '0.00（单位：小时）',
            disabled: true,
            unit: '小时',
          },
          {
            label: '罚款金额',
            value: 'finePrice',
            type: 'input',
            unit: '元',
            onInput: () => {
              const finePrice = this.$refs.baseForm.getVal('finePrice');
              this.$refs.baseForm.setVal('finePrice', finePrice.replace(/\-/g, ''));
            },
          },
          {
            label: '责任司机',
            value: 'userId',
            type: 'select',
          },
          {
            label: '时效描述',
            value: 'remark',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
        ],
        rules: {
          lineNodeIndex: [ // 时效路段
            { required: true, message: '请选择时效路段', trigger: 'blur' },
          ],
          orderStartDate: [ // 离台时间
            { required: true, message: '请选择离台时间', trigger: 'blur' },
          ],
          orderArriveDate: [ // 到达时间
            { required: true, message: '请选择到达时间', trigger: 'blur' },
          ],
          arriveTime: [ // 运输时间
            { required: true, message: '请输入运输时间', trigger: 'blur' },
          ],
          finePrice: [ // 罚款金额
            { required: true, message: '请输入罚款金额', trigger: 'blur' },
          ],
          remark: [ // 时效描述
            { required: false, message: '请输入时效描述', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getList () {
      if (!this.$route.query.orderId) {
        return;
      }
      // 订单详情
      const orderRes = await orderOverviewDetail({
        orderId: this.$route.query.orderId,
      });
      this.orderInfo = orderRes;
      // 时效路段
      const lineRes = await orderTimeLineList({
        orderId: this.$route.query.orderId,
      });
      this.baseForm.lineNodeIndexOptions = lineRes.items.map((item, index) => ({
        label: item.detailLine,
        value: index,
        ...item,
      }));
      // 责任司机列表
      const driverRes = await orderTimeDriverList({
        orderId: this.$route.query.orderId,
      });
      this.baseForm.userIdOptions = driverRes.items.map((item) => ({
        label: item.userName,
        value: item.userId,
        ...item,
      }));
    },

    calcTime () {
      let orderStartDate = this.$refs.baseForm.getVal('orderStartDate') || '';
      let orderArriveDate = this.$refs.baseForm.getVal('orderArriveDate') || '';
      if (orderStartDate) {
        orderStartDate = this.formatDate(orderStartDate, 1);
      }
      if (orderArriveDate) {
        orderArriveDate = this.formatDate(orderArriveDate, 1);
      }
      if (orderStartDate && orderArriveDate) {
        const arriveTime = Number(getHoursDiff(orderStartDate, orderArriveDate)).toFixed(2);
        this.$refs.baseForm.setVal('arriveTime', arriveTime);
      }
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 时效路段
        let lineNode = {};
        for (let i = 0; i < this.baseForm.lineNodeIndexOptions.length; i++) {
          if (this.baseForm.lineNodeIndexOptions[i].value === formData.lineNodeIndex) {
            lineNode = this.baseForm.lineNodeIndexOptions[i];
            break;
          }
        }
        // 责任司机
        let user = {};
        for (let i = 0; i < this.baseForm.userIdOptions.length; i++) {
          if (this.baseForm.userIdOptions[i].value === formData.userId) {
            user = this.baseForm.userIdOptions[i];
            break;
          }
        }
        // 离台时间
        if (formData.orderStartDate) {
          formData.orderStartDate = this.formatDate(formData.orderStartDate, 1);
        }
        // 到达时间
        if (formData.orderArriveDate) {
          formData.orderArriveDate = this.formatDate(formData.orderArriveDate, 1);
        }
        // 运输时间
        formData.arriveHour = formData.arriveTime;
        lineNode.lineNode = lineNode.detailLine;
        formData = {
          ...formData,
          ...lineNode,
          ...user,
        };
      }
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      if (res) {
        if (res.finePrice) {
          res.finePrice = res.finePrice * 100;
        }
      }
      return res;
    },
    async init (data = {}) {
      data = {
        ...data,
        ...this.orderInfo,
      };
      if (data.finePrice) {
        data.finePrice = data.finePrice / 100;
      }
      if (!data.lineNodeIndex) {
        if (this.baseForm.lineNodeIndexOptions && this.baseForm.lineNodeIndexOptions.length) {
          data.lineNodeIndex = this.baseForm.lineNodeIndexOptions[0].value;
          data.orderStartDate = new Date(this.baseForm.lineNodeIndexOptions[0].carStartDate);
          data.orderArriveDate = new Date(this.baseForm.lineNodeIndexOptions[0].carArriveDate);
          data.arriveTime = this.baseForm.lineNodeIndexOptions[0].arrive;
        }
      }
      if (!data.userId) {
        if (this.baseForm.userIdOptions && this.baseForm.userIdOptions.length) {
          data.userId = this.baseForm.userIdOptions[0].value;
        }
      }
      this.$refs.baseForm.setVal(data);
      this.calcTime();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
